(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ipad-timeline"] && !Shopify.designMode) return;
  try {
    
  var lastScrollTop = 0;

function getBlockSectionY() {
  var blockContent = document.querySelectorAll('.block__content__section');
  var blockSectionYArr = [];
  
  for (var i = 0; i < blockContent.length; i++) {
    var rect = blockContent[i].getBoundingClientRect();
    blockSectionYArr.push(rect.top);
  }  
  changeTimeline(blockSectionYArr);
}

function changeTimeline(array) {
  var scrollTop = window.pageYOffset;
  
  for (var i = 0; i < array.length; i++) {
    var timelineItem = document.querySelectorAll('.timeline__list__item');
    
    if (array[i] < -50 && scrollTop > lastScrollTop) {
      timelineItem[i].classList.remove('timeline__list__item--active');
      timelineItem[i + 1].classList.add('timeline__list__item--active');
    }
    else if (array[i] > -50 && scrollTop < lastScrollTop) {
      timelineItem[i].classList.add('timeline__list__item--active');
      timelineItem[i + 1].classList.remove('timeline__list__item--active');
      timelineItem[i + 2].classList.remove('timeline__list__item--active');
      timelineItem[i + 3].classList.remove('timeline__list__item--active');
    };
  }
  lastScrollTop = scrollTop;
  // console.log(scrollTop);
}

getBlockSectionY();

window.addEventListener('scroll', function() {
  var blockSection = document.querySelectorAll('.block__content__section');
  var timelineHeadline = document.querySelectorAll('.timeline__list__item');
  
  getBlockSectionY();
  console.log(window.pageYOffset);
});

window.addEventListener('resize', function() {
  getBlockSectionY();
}) 
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-contact"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", () => {
  const image = document.getElementById("bouncing-image");
  const bounceDuration = 2000;

  const startBounce = () => {
    image.classList.add("bounce");
    setTimeout(() => {
      image.classList.remove("bounce");
    }, bounceDuration);
  };

  image.addEventListener("click", () => {
    window.location.href = "https://wallingtonweb.com";
    startBounce();
  });

  startBounce();
});

$(".tab").on('click', function() {
  $(".tab").removeClass("tab--active");
  $(this).addClass("tab--active");

  if ($(this).hasClass("tab--js--content")) {
    $(".post__content")
      .removeClass("tabs__content--hidden")
      .addClass("tabs__content--revealed");
    $(".post__sidebar")
      .removeClass("tabs__content--revealed")
      .addClass("tabs__content--hidden");
  } else if ($(this).hasClass("tab--js--sidebar")) {
    $(".post__sidebar")
      .removeClass("tabs__content--hidden")
      .addClass("tabs__content--revealed");
    $(".post__content")
      .removeClass("tabs__content--revealed")
      .addClass("tabs__content--hidden");
  }
});

  
  } catch(e) { console.error(e); }
})();
})();
